/**
 * Created by rcabr on 6/28/2016.
 */
angular.module('eStories.resetPw', [
        'eStories.compnt.carousel',
        'eStories.catalog.model'
    ])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.resetPw', {
                url: 'resetPassword/:resetPwToken',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            });
    }]);